import { render } from "./TheSubscriptionProductCreation.vue?vue&type=template&id=3c9946da"
import script from "./TheSubscriptionProductCreation.vue?vue&type=script&lang=js"
export * from "./TheSubscriptionProductCreation.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__